import { useState } from 'react';
import type { IBusiness } from '@recargas-dominicanas/core/types';
import { TextField } from '@recargas-dominicanas/core/components';
import { useForm } from '../../../utils/useForm';
import { Modal } from '../../../components/modal/modal.component';
import { useBusinessListStore } from '../../../stores/businessListStore';
import { BusinessApi } from '../../../api/business.api';
import { emptyToUndefine } from '../../../utils/emptyToUndefine';
import { style } from './edit-business-modal.module.css';

interface Props {
  open: boolean;
  business: IBusiness;
  onClose: () => void;
}

export function EditBusinessModal(props: Props) {

  const { open, business, onClose } = props;

  const businessListStore = useBusinessListStore();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  
  const form = useForm({
    name: props.business.name,
    rnc: { value: props.business.rnc ?? '', optional: true },
    phone: { value: props.business.phone ?? '', optional: true },
    email: { value: props.business.email ?? '', optional: true },
    city: props.business.city,
    address: props.business.address
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      setLoading(true);

      await BusinessApi.update(business.id, {
        name: form.name.value,
        rnc: emptyToUndefine(form.rnc.value),
        phone: emptyToUndefine(form.phone.value),
        email: emptyToUndefine(form.email.value),
        city: form.city.value,
        address: form.address.value
      });

      await businessListStore.fetch();

      setLoading(false);
      handleClose();

    } catch {

      setLoading(false);
      setError('Error actualizando negocio');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Editar negocio'
      style={style.modal}
      disabledSecondaryButton={loading}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <TextField 
        style={style.textField}
        label='Nombre'
        value={form.name.value}
        error={form.name.error}
        onChange={form.name.onChange}
        onBlur={form.name.onBlur}/>
      <TextField 
        style={style.textField}
        label='RNC (opcional)'
        value={form.rnc.value}
        error={form.rnc.error}
        onChange={form.rnc.onChange}
        onBlur={form.rnc.onBlur}/>
      <TextField 
        style={style.textField}
        label='Teléfono (opcional)'
        value={form.phone.value}
        error={form.phone.error}
        onChange={form.phone.onChange}
        onBlur={form.phone.onBlur}/>
      <TextField 
        style={style.textField}
        label='Email (opcional)'
        value={form.email.value}
        error={form.email.error}
        onChange={form.email.onChange}
        onBlur={form.email.onBlur}/>
      <TextField 
        style={style.textField}
        label='Ciudad'
        value={form.city.value}
        error={form.city.error}
        onChange={form.city.onChange}
        onBlur={form.city.onBlur}/>
      <TextField 
        style={style.textField}
        label='Dirección'
        value={form.address.value}
        error={form.address.error}
        onChange={form.address.onChange}
        onBlur={form.address.onBlur}/>
    </Modal>
  );
}
